import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';

const ContattiPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  
  const contactPageData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contatti - AGRO-INNOVAZIONI S.r.l',
    description: 'Contatta AGRO-INNOVAZIONI per informazioni sui nostri prodotti biologici. Sede a Milano e Sassuolo.',
    url: `${siteUrl}/contatti`,
    mainEntity: {
      '@type': 'Organization',
      name: 'AGRO-INNOVAZIONI S.r.l',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg',
      telephone: '+39-0230310856',
      email: 'info@agro-innovazioni.it',
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: 'Via Example 123',
          addressLocality: 'Milano',
          addressRegion: 'MI',
          postalCode: '20100',
          addressCountry: 'IT',
        },
        {
          '@type': 'PostalAddress',
          streetAddress: 'Via Example 456',
          addressLocality: 'Sassuolo',
          addressRegion: 'MO',
          postalCode: '41049',
          addressCountry: 'IT',
        },
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+39-0230310856',
        contactType: 'customer service',
        email: 'info@agro-innovazioni.it',
        availableLanguage: ['Italian', 'English'],
        areaServed: 'IT',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      },
    },
  };

  return (
    <>
      <SEOHead
        title="Contatti - AGRO-INNOVAZIONI S.r.l | Milano e Sassuolo"
        description="Contatta AGRO-INNOVAZIONI per informazioni sui nostri prodotti biologici. Telefono: 0230310856, Email: info@agro-innovazioni.it. Sede a Milano e Sassuolo."
        keywords="contatti AGRO-INNOVAZIONI, telefono spezie bio, email biscotti bio, sede Milano, sede Sassuolo"
        ogTitle="Contatti - AGRO-INNOVAZIONI S.r.l | Milano e Sassuolo"
        ogDescription="Contatta AGRO-INNOVAZIONI per informazioni sui nostri prodotti biologici. Telefono: 0230310856, Email: info@agro-innovazioni.it."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/contatti`}
      />
      <StructuredData type="ContactPage" data={contactPageData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20">
          <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[calc(100vh-80px)]">
            <ContactInfo />
            <ContactForm />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ContattiPage;
